export default __webpack_public_path__ + "static/media/internet.e73117cf.svg";